//React Components and Hooks
import React, { useState, useRef, useEffect } from 'react';
import {
    BrowserRouter as Router,
    Route,
    Navigate,
    useNavigate,
    useLocation
} from "react-router-dom";
import styled from "styled-components";
import { NavLink } from "react-router-dom";
import moment from 'moment';
import Helmet from "react-helmet";

import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Slide from "@mui/material/Slide";
import {
    Avatar,
    Breadcrumbs as MuiBreadcrumbs,
    Button as MuiButton,
    Button,
    Box,
    Card as MuiCard,
    CardContent,
    Divider as MuiDivider,
    FormControl as MuiFormControl,
    Link,
    TextField as MuiTextField,
    Typography,
    InputLabel,
    Select,
    MenuItem,
    CircularProgress as MuiCircularProgress,
    Skeleton,
} from "@mui/material";
import Alert from "@mui/material/Alert";
import { TimePicker, DatePicker, DateTimePicker } from "@mui/x-date-pickers";
import { spacing } from "@mui/system";
import NativeSelect from '@mui/material/NativeSelect';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import PropertyUtilityForm from "../../../../modules/propertyUtility/components/Form";
// Redux Components
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { logout } from '../../../../modules/user/api/actions';
import { getAllPropertyPreviews } from '../../../../modules/apl/api/actions';
import { updateBillingWizardSelectedProperty, updateBillingWizardBillInProgress, getAllUnsettledPropertyMeterReadingsByPropertyUUID, handleBillingProcessSubmission, getSelectedBillWizPropertyInfoByPropUUID, getRiderRatePreview } from '../../../../modules/billing/api/actions';
import { getByUuid as getPropertyByUuid, getAllCommonChargeRelatedDataByPropertyId } from "../../../../modules/property/api/actions";
import { getByPropertyId as getPropertyUtilityByPropertyId } from "../../../../modules/propertyUtility/api/actions";
import EditIcon from "@mui/icons-material/Edit";
//Material UI Components and Functions
import { makeStyles } from '@mui/styles';
import { withStyles } from '@mui/styles';

import { dateFormatter, txtBoxDateFormatter, formatMoney, CalculateSelectedPropertyTotalCommonsCharge } from "../../../../setup/helpers";

const CenteredContent = styled.div`
  text-align: center;
`;
const CircularProgress = styled(MuiCircularProgress)(spacing);
const Card = styled(MuiCard)(spacing);
const Divider = styled(MuiDivider)(spacing);
const FormControl = styled(MuiFormControl)(spacing);
const TextField = styled(MuiTextField)(spacing);


const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

function getWizardBillDateAsOf(billInformation) {
    const raw = billInformation?.billDate;
    if (!raw) {
        return moment().format("YYYY-MM-DD");
    }
    const parsed = moment(raw);
    return parsed.isValid() ? parsed.format("YYYY-MM-DD") : moment().format("YYYY-MM-DD");
}

function getResolvedSourceCaption(resolved, vendorName, billDateAsOf) {
    const source = resolved?.source || "none";
    const vendor = vendorName || "vendor";
    const vendorUuid = resolved?.vendorUuid || null;
    const hasVendor = Boolean(vendorUuid || vendorName);
    const vendorCount = resolved?.vendorRiders?.length || 0;
    const propertyCount = resolved?.propertyOverrides?.length || 0;

    if (source === "merged") {
        return `Bill date ${billDateAsOf} · ${vendor} · ${vendorCount} vendor rate(s) + ${propertyCount} property rate(s)`;
    }
    if (source === "vendor") {
        return `Bill date ${billDateAsOf} · All rates from ${vendor}`;
    }
    if (source === "property") {
        if (hasVendor) {
            return `Bill date ${billDateAsOf} · Property rates — ${vendor} has no vendor rider rates uploaded yet`;
        }
        return `Bill date ${billDateAsOf} · Property-only rates — assign a vendor on Property Utility to use vendor defaults`;
    }
    if (hasVendor) {
        return `Bill date ${billDateAsOf} · No rider rates for ${vendor} or this property`;
    }
    return `Bill date ${billDateAsOf} · No rider rates configured for this property`;
}

// Custom Styles for property selection drop down


const useStyles = makeStyles((theme) => ({
    container: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    selectedPropertyLocationLabel: {
        fontSize: 30,
        backgroundColor: "#fffffff",
        borderColor: "#fffffff",
    },
    loadingIcon: {
        position: 'absolute', left: '50%', top: '50%',
        transform: 'translate(-50%, -50%)'
    },
    dropDownLoadingIcon: {
        position: 'absolute', left: '50%', top: '50%',
        transform: 'translate(-50%, -50%)'
    }
}));


const BillingInformationForm = (props) => {
    const [property, setProperty] = React.useState(props.billing.data.billInProgress.billInformation.propertyUUID);
    const [billInformationFormObject, setBillInformationFormObject] = React.useState(props.billing.data.billInProgress.billInformation);
    const [currentTestKWH, setCurrentTestKWH] = React.useState(props.properties.currentRiderRateTestKwhCharge);
    const [riderRateTestProduct, setRiderRateTestProduct] = React.useState([]);
    const [riderRateTestProductSummary, setRiderRateTestProductSummary] = React.useState(null);
    const [previewMeta, setPreviewMeta] = React.useState(null);
    const [previewIsLoading, setPreviewIsLoading] = React.useState(false);
    const [initalCommonAreaLoading, setInitalCommonAreaLoading] = React.useState(false);
    const lastLoadedPropertyIdRef = React.useRef(null);

    const [display, setDisplay] = React.useState(false);

    const toggleDisplay = () => {
        const shouldDisplay = !display;
        setDisplay(shouldDisplay);
    };


    const navigate = useNavigate();
    // Updates the local state object of "bill in progress" upon each modification
    const onFieldChange = (event) => {
        if (event.target.type == "number") {
            props.billing.data.billInProgress.billInformation[event.target.name] = Number(event.target.value);
        }
        else {
            props.billing.data.billInProgress.billInformation[event.target.name] = event.target.value;
        }
        if (event.target.name === "billDate") {
            props.updateBillingWizardBillInProgress(props.billing.data.billInProgress);
        }
    }

    // const HandleTextBoxDisselect = (event) => {
    //     props.handleBillingProcessSubmission(props.billing.data.billInProgress, false);
    // }

    const EvaluateFormObject = () => {
        var newErrors = [];
        // Amount warnings
        //newErrors.push("This is my sample error message");
        props.billing.data.billInProgress.billInformationErrors = newErrors;
        // on error checking update the store and tell 
        if (newErrors.length > 0) {
            props.updateBillingWizardBillInProgress(props.billing.data.billInProgress);
            return false;
        }
        props.updateBillingWizardBillInProgress(props.billing.data.billInProgress);
        return true;
    }


    const fetchRiderRatePreview = React.useCallback(async () => {
        const propertyUuid = props.billing.data.billInProgress.billInformation.propertyUUID;
        if (
            !propertyUuid ||
            !props.propertyUtilities.data.propertyUtility ||
            !props.properties.data.property?.id
        ) {
            return;
        }

        const billDateAsOf = getWizardBillDateAsOf(props.billing.data.billInProgress.billInformation);
        const unitCount = props.properties.data.property.totalUnits || 1;

        setPreviewIsLoading(true);
        try {
            const response = await getRiderRatePreview(propertyUuid, billDateAsOf, 1, unitCount);
            const data = response.data;

            let commonAreaTotal = 0;
            if (
                !props.properties.propertyResidualAmountsToAddIsLoading &&
                !props.properties.propertyAdditionalCommonAreaExpensesIsLoading &&
                !props.properties.isLoading
            ) {
                commonAreaTotal = CalculateSelectedPropertyTotalCommonsCharge(
                    props.properties.propertyAdditionalCommonAreaExpenses,
                    props.properties.propertyResidualAmountsToAdd,
                    unitCount
                );
            }

            setPreviewMeta({
                source: data.source,
                vendorUuid: data.vendorUuid || null,
                vendorRiders: data.vendorRiders,
                propertyOverrides: data.propertyOverrides,
                effectiveBaseCharge: data.effectiveBaseCharge,
            });
            setRiderRateTestProductSummary({
                ...(data.bill || {}),
                commonAreaTotal: commonAreaTotal || 0,
            });
            setRiderRateTestProduct(data.riders || []);
        } catch (err) {
            console.error(err);
            setPreviewMeta(null);
            setRiderRateTestProductSummary(null);
            setRiderRateTestProduct([]);
        } finally {
            setPreviewIsLoading(false);
        }
    }, [
        props.billing.data.billInProgress.billInformation.propertyUUID,
        props.billing.data.billInProgress.billInformation.billDate,
        props.propertyUtilities.data.propertyUtility,
        props.properties.data.property?.id,
        props.properties.data.property?.totalUnits,
        props.properties.propertyResidualAmountsToAddIsLoading,
        props.properties.propertyAdditionalCommonAreaExpensesIsLoading,
        props.properties.isLoading,
        props.properties.propertyAdditionalCommonAreaExpenses,
        props.properties.propertyResidualAmountsToAdd,
    ]);


    const classes = useStyles();
    // Should pass the index of the selected property as found in the apl "properties" array, and it passes that object to be merged
    const handleSelectedPropertyChange = (event) => {
        setProperty(event.target.value);
        var selectedProperty = props.apl.data.propertyPreviews.find(obj => {
            return obj.uuid === event.target.value
        })
        // NOTE: Copout this is what onfield change does basically so its sloppy to have twice. did it because value on event is array index not uuid 
        // Calls field change method to update the value in the redux store
        props.billing.data.billInProgress.billInformation.propertyUUID = event.target.value;
        // props.billing.data.billInProgress.currentStep = 1;
        // Replaces existing store object with new object with modified sub data
        props.updateBillingWizardBillInProgress(props.billing.data.billInProgress);


        // Has to merge the selected property into the state with the selected property details and loads all necessary property assets for the form
        props.updateBillingWizardSelectedProperty(selectedProperty);
        if (selectedProperty && (selectedProperty.uuid || selectedProperty.id)) {
            props.getSelectedBillWizPropertyInfoByPropUUID(selectedProperty.uuid || selectedProperty.id);
        }
    };

    useEffect(() => {
        if (
            !props.properties.propertyAdditionalCommonAreaExpensesIsLoading &&
            !props.properties.propertyResidualAmountsToAddIsLoading &&
            !props.properties.data.property.isLoading &&
            !props.propertyUtilities.propertyUtilityIsLoading &&
            props.billing.data.billInProgress.billInformation.propertyUUID &&
            props.properties.data.property?.id &&
            props.propertyUtilities.data.propertyUtility
        ) {
            fetchRiderRatePreview();
        }
        if (props.billing.data.billInProgress.billInformation.propertyUUID != "" && props.properties.data.property && !props.properties.data.property.totalUnits && !props.properties.data.property.id && !props.properties.data.property.isLoading) {
            var selectedProperty = props.apl.data.propertyPreviews.find(obj => {
                return obj.uuid === props.billing.data.billInProgress.billInformation.propertyUUID
            })
            if (!initalCommonAreaLoading && selectedProperty) {
                if (selectedProperty.id) {
                    // Only call if not already loading and property changed or we don't have data for this property
                    if (!props.propertyUtilities.propertyUtilityIsLoading && 
                        (lastLoadedPropertyIdRef.current !== selectedProperty.id || 
                         !props.propertyUtilities.data.propertyUtility ||
                         (props.propertyUtilities.data.propertyUtility.propertyId && 
                          props.propertyUtilities.data.propertyUtility.propertyId !== selectedProperty.id))) {
                        props.getPropertyUtilityByPropertyId(selectedProperty.id);
                        lastLoadedPropertyIdRef.current = selectedProperty.id;
                    }
                    props.getAllCommonChargeRelatedDataByPropertyId(selectedProperty.id);
                }
                if (selectedProperty.uuid) {
                    props.getPropertyByUuid(selectedProperty.uuid);
                }
                setInitalCommonAreaLoading(true);
            }
        }
    }, [
        fetchRiderRatePreview,
        props.properties.propertyAdditionalCommonAreaExpensesIsLoading,
        props.properties.propertyResidualAmountsToAddIsLoading,
        props.properties.data.property.isLoading,
        props.propertyUtilities.propertyUtilityIsLoading,
        props.billing.data.billInProgress.billInformation.billDate,
        props.billing.data.billInProgress.billInformation.propertyUUID,
    ]);

    return (
        <Card mb={6} elevation={3}>
            <CardContent>
                {/* Main Form Layout */}
                <Box sx={{ 
                  display: 'flex', 
                  flexWrap: 'wrap', 
                  gap: 3, 
                  width: '100%',
                  mb: 3,
                  alignItems: 'flex-start',
                  justifyContent: 'flex-start'
                }}>
                    {/*             Col 1            */}
                    {props.billing.data.billInProgress.trialBillingItems.items.length == 0 && !props.billing.data.billInProgress.generateTrialBilling ?
                        <Box sx={{ flex: { xs: '1 1 100%', sm: '1 1 100%', md: '1 1 100%', lg: '1 1 calc(33.33% - 16px)' } }}>
                            <FormControl fullWidth my={2}>
                                <InputLabel id="propertyToBillDropDownLabel">Location{"  "}
                                    {props.apl.isLoading &&
                                        <CircularProgress size={15} m={0} />
                                    }
                                </InputLabel>
                                {property == "" && props.apl.isLoading ?
                                    <Select
                                        labelId="propertyToBillDropDownLabel"
                                        id="propertyToBillDropDown"
                                        className={classes.selectedPropertyLocationLabel}
                                        onChange={handleSelectedPropertyChange}
                                        fullWidth
                                        disabled
                                        my={2}>
                                    </Select>
                                    :
                                    <Select
                                        labelId="propertyToBillDropDownLabel"
                                        id="propertyToBillDropDown"
                                        value={props.billing.data.billInProgress.billInformation.propertyUUID}
                                        className={classes.selectedPropertyLocationLabel}
                                        onChange={handleSelectedPropertyChange}
                                        fullWidth
                                        my={2}>
                                        {props.apl.data.propertyPreviews.length > 0 ?
                                            [
                                                props.apl.data.propertyPreviews.map((item, key) => {
                                                    return (
                                                        <MenuItem value={item.uuid} id={key}>{item.name}</MenuItem>
                                                    )
                                                })
                                            ]
                                            :
                                            [
                                                <MenuItem value={-1}>No Properties Found</MenuItem>
                                            ]
                                        }
                                    </Select>
                                }
                            </FormControl>
                        </Box>
                        :
                        <Box sx={{ flex: { xs: '1 1 100%', sm: '1 1 100%', md: '1 1 100%', lg: '1 1 calc(33.33% - 16px)' } }}>
                            <FormControl fullWidth my={2}>
                                <InputLabel id="propertyToBillDropDownLabel">Location{"  "}
                                </InputLabel>
                                <Select
                                    labelId="propertyToBillDropDownLabel"
                                    id="propertyToBillDropDown"
                                    value={props.billing.data.billInProgress.billInformation.propertyUUID}
                                    disabled
                                    className={classes.selectedPropertyLocationLabel}
                                    onChange={handleSelectedPropertyChange}
                                    fullWidth
                                    my={2}>
                                    {props.apl.data.propertyPreviews.length > 0 ?
                                        [
                                            props.apl.data.propertyPreviews.map((item, key) => {
                                                return (
                                                    <MenuItem value={item.uuid} id={key}>{item.name}</MenuItem>
                                                )
                                            })
                                        ]
                                        :
                                        [
                                            <MenuItem value={-1}>No Properties Found</MenuItem>
                                        ]
                                    }
                                </Select>
                            </FormControl>
                        </Box>
                    }
                    {/*             Col 2            */}
                    <Box sx={{ flex: { xs: '1 1 100%', sm: '1 1 100%', md: '1 1 100%', lg: '1 1 calc(33.33% - 16px)' } }}>
                        <TextField
                            my={2}
                            fullWidth
                            type="date"
                            id="billDate"
                            label="Billing Date"
                            defaultValue={txtBoxDateFormatter(props.billing.data.billInProgress.billInformation.billDate)}
                            onChange={onFieldChange}
                            // onBlur={HandleTextBoxDisselect}
                            //onBlur={() =>{ props.handleBillingProcessSubmission(props.billing.data.billInProgress, false); } }
                            variant="outlined"
                            name="billDate"
                            InputLabelProps={{
                                shrink: true,
                            }}
                        />
                    </Box>
                    <Box sx={{ flex: { xs: '1 1 100%', sm: '1 1 100%', md: '1 1 100%', lg: '1 1 calc(33.33% - 16px)' } }}>
                        <TextField
                            id="dueDate"
                            label="Due Date"
                            type="date"
                            fullWidth
                            my={2}
                            variant="outlined"
                            InputLabelProps={{
                                shrink: true,
                            }}
                            defaultValue={props.billing.data.billInProgress.billInformation.dueDate != props.billing.defaultDateValue &&
                                txtBoxDateFormatter(props.billing.data.billInProgress.billInformation.dueDate)
                            }
                            onChange={onFieldChange}
                            // onBlur={HandleTextBoxDisselect}
                            //onBlur={() =>{ props.handleBillingProcessSubmission(props.billing.data.billInProgress, false); } }
                            name="dueDate"
                        />
                    </Box>
                    <Box sx={{ flex: { xs: '1 1 100%', sm: '1 1 100%', md: '1 1 100%', lg: '1 1 calc(33.33% - 16px)' } }}>
                        <TextField
                            id="nextReadDate"
                            label="Next Read Date"
                            type="date"
                            my={2}
                            fullWidth
                            variant="outlined"
                            InputLabelProps={{
                                shrink: true,
                            }}
                            defaultValue={txtBoxDateFormatter(props.billing.data.billInProgress.billInformation.nextReadDate)}
                            onChange={onFieldChange}
                            // onBlur={HandleTextBoxDisselect}
                            //onBlur={() =>{ props.handleBillingProcessSubmission(props.billing.data.billInProgress, false); } }
                            name="nextReadDate"
                        />
                    </Box>
                    {/*             Col 3           */}
                    <Box sx={{ flex: { xs: '1 1 100%', sm: '1 1 100%', md: '1 1 100%', lg: '1 1 calc(66.67% - 12px)' } }}>
                        <TextField
                            label="Bill Message"
                            id="customBillMessage"
                            multiline={true}
                            rows={10}
                            autoComplete={"off"}
                            rowsMax={10}
                            variant="outlined"
                            my={2}
                            fullWidth
                            InputLabelProps={{
                                shrink: true,
                            }}
                            defaultValue={billInformationFormObject.billMessage}
                            onChange={onFieldChange}
                            // onBlur={HandleTextBoxDisselect}
                            //onBlur={() =>{ props.handleBillingProcessSubmission(props.billing.data.billInProgress, false); } }
                            name="billMessage"
                        />
                    </Box>
                </Box>
                {/*  loading when property is selected  */}
                {props.billing.data.billInProgress.billInformation.propertyUUID && 
                 (props.propertyUtilities.propertyUtilityIsLoading || 
                  previewIsLoading ||
                  props.properties.propertyAdditionalCommonAreaExpensesIsLoading || 
                  props.properties.propertyResidualAmountsToAddIsLoading || 
                  props.properties.data.property.isLoading ||
                  !props.propertyUtilities.data.propertyUtility ||
                  !props.properties.data.property ||
                  !props.properties.data.property.id ||
                  riderRateTestProductSummary == null) &&
                    <Box sx={{ 
                      display: 'flex', 
                      flexWrap: 'wrap', 
                      gap: 2, 
                      width: '100%',
                      mt: 3,
                      alignItems: 'flex-start',
                      justifyContent: 'flex-start'
                    }}>
                        <Box sx={{ width: '100%', mt: 2, pt: 2 }}>
                            <Skeleton variant="text" width="60%" height={40} />
                            <Divider className="mt-2" sx={{ mt: 2 }} />
                        </Box>
                        {[...Array(4)].map((_, index) => (
                            <Box key={index} sx={{ flex: { xs: '1 1 100%', sm: '1 1 100%', md: '1 1 calc(33.33% - 11px)', lg: '1 1 calc(33.33% - 11px)' } }}>
                                <Skeleton variant="text" width="80%" height={24} />
                                <Skeleton variant="text" width="60%" height={20} />
                            </Box>
                        ))}
                        <Box sx={{ width: '100%', mt: 2, pt: 2 }}>
                            <Skeleton variant="text" width="50%" height={40} />
                            <Divider className="mt-2" sx={{ mt: 2 }} />
                        </Box>
                        {[...Array(2)].map((_, index) => (
                            <Box key={index} sx={{ flex: { xs: '1 1 100%', sm: '1 1 100%', md: '1 1 100%', lg: '1 1 calc(50% - 8px)' } }}>
                                <Skeleton variant="text" width="70%" height={24} />
                            </Box>
                        ))}
                        <Box sx={{ width: '100%' }}>
                            <Divider className="mb-2 mt-2" my={1} />
                        </Box>
                    </Box>
                }
                {(riderRateTestProductSummary != null && props.properties.data.property && props.properties.data.property.id && props.propertyUtilities.data.propertyUtility) &&
                    (() => {
                        const propertyUtility = props.propertyUtilities.data.propertyUtility;
                        const resolved = previewMeta;
                        const effective = resolved?.effectiveBaseCharge;
                        const billDateAsOf = getWizardBillDateAsOf(props.billing.data.billInProgress.billInformation);
                        const billingCustomerCharge = effective?.customerCharge != null
                            ? Number(effective.customerCharge)
                            : Number(propertyUtility.utilCustomerCharge) || 0;
                        const billingEnergyRate = effective?.energyChargeRate != null
                            ? Number(effective.energyChargeRate)
                            : Number(propertyUtility.utilEnergyCharge) || 0;
                        const propertyCustomerCharge = Number(propertyUtility.utilCustomerCharge) || 0;
                        const propertyEnergyRate = Number(propertyUtility.utilEnergyCharge) || 0;
                        const chargesDiffer = effective && (
                            billingCustomerCharge !== propertyCustomerCharge ||
                            billingEnergyRate !== propertyEnergyRate
                        );
                        const sourceCaption = getResolvedSourceCaption(
                            resolved,
                            propertyUtility.vendorName,
                            billDateAsOf
                        );
                        const basePlusEnergy = (Number(riderRateTestProductSummary.utilCustomerCharge) || billingCustomerCharge)
                            + (Number(riderRateTestProductSummary.utilEnergyCharge) || 0);

                        return (
                    <Box sx={{ 
                      display: 'flex', 
                      flexWrap: 'wrap', 
                      gap: 2, 
                      width: '100%',
                      mt: 3,
                      alignItems: 'flex-start',
                      justifyContent: 'flex-start'
                    }}>
                        <Box sx={{ width: '100%', mt: 2, pt: 2 }}>
                            <Typography variant="h5" className="mt-2 pt-2">
                                Billing Rate Preview{" "}
                                <Button onClick={toggleDisplay} aria-label="Edit property utility settings">
                                    <EditIcon fontSize="medium" />
                                </Button>
                            </Typography>
                            <Typography variant="caption" color="text.secondary" display="block" sx={{ mt: 0.5 }}>
                                {sourceCaption}
                            </Typography>
                            {effective?.source === "vendorBaseCharge" ? (
                                <Typography variant="caption" color="text.secondary" display="block">
                                    Base charges from vendor base charges
                                </Typography>
                            ) : null}
                            <Dialog
                                open={display}
                                TransitionComponent={Transition}
                                fullWidth={"lg"}
                                maxWidth={"lg"}
                                keepMounted
                                onClose={toggleDisplay}
                                aria-labelledby="alert-dialog-slide-title"
                                aria-describedby="alert-dialog-slide-description"
                            >
                                {propertyUtility ? (
                                    <DialogTitle id="alert-dialog-slide-title">
                                        Edit property utility settings — {propertyUtility.name}{" "}
                                    </DialogTitle>
                                ) : (
                                    <DialogTitle id="alert-dialog-slide-title">
                                        Loading Utilities.....{" "}
                                    </DialogTitle>
                                )}
                                <DialogContent>
                                    {propertyUtility && (
                                        <PropertyUtilityForm
                                            onUpdate={toggleDisplay}
                                            onCancel={toggleDisplay}
                                            serviceOutage={propertyUtility.serviceOutage || 0}
                                            active={propertyUtility.active || 0}
                                        />
                                    )}
                                </DialogContent>
                            </Dialog>
                            <Divider className="mt-2" sx={{ mt: 2 }} />
                        </Box>
                        <Box sx={{ flex: { xs: '1 1 100%', sm: '1 1 100%', md: '1 1 calc(33.33% - 11px)', lg: '1 1 calc(33.33% - 11px)' } }}>
                            <Typography variant="body1">
                                Customer charge (billing):
                            </Typography>
                            <Typography variant="caption">
                                {formatMoney(billingCustomerCharge)}
                            </Typography>
                            {chargesDiffer ? (
                                <Typography variant="caption" color="text.secondary" display="block">
                                    Property utility record: {formatMoney(propertyCustomerCharge)}
                                </Typography>
                            ) : null}
                        </Box>
                        <Box sx={{ flex: { xs: '1 1 100%', sm: '1 1 100%', md: '1 1 calc(33.33% - 11px)', lg: '1 1 calc(33.33% - 11px)' } }}>
                            <Typography variant="body1">
                                Energy rate $/kWh (billing):
                            </Typography>
                            <Typography variant="caption">
                                $ {(billingEnergyRate).toFixed(7)}
                            </Typography>
                            {chargesDiffer ? (
                                <Typography variant="caption" color="text.secondary" display="block">
                                    Property utility record: $ {propertyEnergyRate.toFixed(7)}
                                </Typography>
                            ) : null}
                        </Box>
                        <Box sx={{ flex: { xs: '1 1 100%', sm: '1 1 100%', md: '1 1 calc(33.33% - 11px)', lg: '1 1 calc(33.33% - 11px)' } }}>
                            <Typography variant="body1">
                                Contract Rate :
                            </Typography>
                            <Typography variant="caption">
                                $  {(propertyUtility.contractRate || formatMoney(0))}
                            </Typography>
                        </Box>
                        <Box sx={{ flex: { xs: '1 1 100%', sm: '1 1 100%', md: '1 1 calc(33.33% - 11px)', lg: '1 1 calc(33.33% - 11px)' } }}>
                            <Typography variant="body1">
                                EV Meter Rate :
                            </Typography>
                            <Typography variant="caption">
                                $  {(propertyUtility.EVMeterRate || formatMoney(0))}
                            </Typography>
                        </Box>
                        <Box sx={{ width: '100%', mt: 2, pt: 2, className: 'mt-2 pt-2' }}>
                            <Typography variant="h5" className="mt-2 pt-2">
                                Saved Property Commons Area Charges
                            </Typography>
                            <Divider className="mt-2" />
                        </Box>
                        <Box sx={{ flex: { xs: '1 1 100%', sm: '1 1 100%', md: '1 1 100%', lg: '1 1 calc(50% - 8px)' } }}>
                            <Typography variant="body1">
                                Current Common Charge/Account: $ {(riderRateTestProductSummary.commonAreaTotal || 0).toFixed(4)}
                            </Typography>
                        </Box>
                        <Box sx={{ flex: { xs: '1 1 100%', sm: '1 1 100%', md: '1 1 100%', lg: '1 1 calc(50% - 8px)' } }}>
                            <Typography variant="body1">
                                Rider charges @ 1 kWh (D/G/T only): $ {(riderRateTestProductSummary.utilRidersTotal || 0).toFixed(4)}
                            </Typography>
                        </Box>
                        <Box sx={{ flex: { xs: '1 1 100%', sm: '1 1 100%', md: '1 1 100%', lg: '1 1 calc(50% - 8px)' } }}>
                            <Typography variant="body1">
                                Customer + energy @ 1 kWh: $ {basePlusEnergy.toFixed(4)}
                            </Typography>
                        </Box>
                        <Box sx={{ flex: { xs: '1 1 100%', sm: '1 1 100%', md: '1 1 100%', lg: '1 1 calc(50% - 8px)' } }}>
                            <Typography variant="body1">
                                Estimated unit charge @ 1 kWh: $ {(riderRateTestProductSummary.totalCharge || 0).toFixed(4)}
                            </Typography>
                            <Typography variant="caption" color="text.secondary">
                                Excludes common area charges
                            </Typography>
                        </Box>
                        <Box sx={{ width: '100%', mt: 2, pt: 2 }}>
                            <Typography variant="h5" className="mt-2 pt-2">
                                Generation / Transmission / Distribution @ 1 kWh
                            </Typography>
                            <Typography variant="caption" color="text.secondary" display="block" sx={{ mb: 1 }}>
                                Distribution includes customer charge and energy charge (matches bill line items)
                            </Typography>
                            <Divider className="mt-2" />
                        </Box>
                        <Box sx={{ flex: { xs: '1 1 100%', sm: '1 1 100%', md: '1 1 calc(33.33% - 11px)', lg: '1 1 calc(33.33% - 11px)' } }}>
                            <Typography variant="body1">
                                Generation:
                            </Typography>
                            <Typography variant="caption">
                                $ {(riderRateTestProductSummary.utilGenerationTotal || 0).toFixed(4)}
                            </Typography>
                        </Box>
                        <Box sx={{ flex: { xs: '1 1 100%', sm: '1 1 100%', md: '1 1 calc(33.33% - 11px)', lg: '1 1 calc(33.33% - 11px)' } }}>
                            <Typography variant="body1">
                                Transmission:
                            </Typography>
                            <Typography variant="caption">
                                $ {(riderRateTestProductSummary.utilTransmissionTotal || 0).toFixed(4)}
                            </Typography>
                        </Box>
                        <Box sx={{ flex: { xs: '1 1 100%', sm: '1 1 100%', md: '1 1 calc(33.33% - 11px)', lg: '1 1 calc(33.33% - 11px)' } }}>
                            <Typography variant="body1">
                                Distribution:
                            </Typography>
                            <Typography variant="caption">
                                $ {(riderRateTestProductSummary.utilDistributionTotal || 0).toFixed(4)}
                            </Typography>
                        </Box>
                        <Box sx={{ width: '100%' }}>
                            <Divider className="mb-2 mt-2" my={1} />
                        </Box>
                    </Box>
                        );
                    })()
                }
            </CardContent>
        </Card>
    );
}
// Component Properties
BillingInformationForm.propTypes = {
    // Store objects:
    user: PropTypes.object.isRequired,
    apl: PropTypes.object.isRequired,
    billing: PropTypes.object.isRequired,
    properties: PropTypes.object.isRequired,
    propertyUtilities: PropTypes.object.isRequired,
    // Store object functions:
    getAllPropertyPreviews: PropTypes.func.isRequired,
    updateBillingWizardSelectedProperty: PropTypes.func.isRequired,
    updateBillingWizardBillInProgress: PropTypes.func.isRequired,
    getAllUnsettledPropertyMeterReadingsByPropertyUUID: PropTypes.func.isRequired,
    handleBillingProcessSubmission: PropTypes.func.isRequired,
    getSelectedBillWizPropertyInfoByPropUUID: PropTypes.func.isRequired,

    getAllCommonChargeRelatedDataByPropertyId: PropTypes.func.isRequired,
    getPropertyByUuid: PropTypes.func.isRequired,
    getPropertyUtilityByPropertyId: PropTypes.func.isRequired,
}

// Component State
function BillingInformationFormState(state) {
    return {
        user: state.user,
        apl: state.apl,
        billing: state.billing,
        properties: state.properties,
        propertyUtilities: state.propertyUtilities
    }
}
export default connect(BillingInformationFormState, { getAllCommonChargeRelatedDataByPropertyId, getPropertyByUuid, getPropertyUtilityByPropertyId, logout, updateBillingWizardSelectedProperty, updateBillingWizardBillInProgress, getAllPropertyPreviews, handleBillingProcessSubmission, getSelectedBillWizPropertyInfoByPropUUID, getAllUnsettledPropertyMeterReadingsByPropertyUUID })(BillingInformationForm)